import { Divider, List, ListItem, ListItemText } from "@material-ui/core";
import { Role, User } from "api";
import { useFormikContext } from "formik";
import React, { useContext } from "react";
import { BoxCard, LoggedUserContext } from "ui/componentes";

export enum ProfileMenuType {
    PROFILE = "PROFILE",
    DRIVER_INFORMATION = "DRIVER_INFORMATION",
    ROLES = "ROLES",
    PASSWORD_RESET = "PASSWORD_RESET",
}

interface ProfileMenuProps {
    selectedMenu: ProfileMenuType;
    onMenuChange?: (selectedMenu: ProfileMenuType) => void;
}

const onClickMenu = (
    selectedMenu: ProfileMenuType,
    onMenuChange?: (selectedMenu: ProfileMenuType) => void
) => () => {
    if (onMenuChange) {
        onMenuChange(selectedMenu);
    }
};

const ProfileMenu: React.FC<ProfileMenuProps> = ({
    selectedMenu,
    onMenuChange,
}) => {
    let profileHasError = false;
    let driverInformationHasError = false;

    const { errors } = useFormikContext<User>();

    const loggedUser = useContext(LoggedUserContext);

    if (errors) {
        const { driverInfo, ...profileErrors } = errors;
        if (driverInfo) {
            driverInformationHasError =
                Object.getOwnPropertyNames(driverInfo).length > 0;
        }
        profileHasError = Object.keys(profileErrors).length > 0;
    }

    return (
        <BoxCard padding={0}>
            <List>
                <ListItem
                    button
                    selected={selectedMenu === ProfileMenuType.PROFILE}
                    onClick={onClickMenu(ProfileMenuType.PROFILE, onMenuChange)}
                >
                    <ListItemText
                        style={{ color: profileHasError ? "red" : "" }}
                        primary={`Perfil ${profileHasError ? "*" : ""}`}
                    />
                </ListItem>
                <Divider />
                <ListItem
                    button
                    selected={
                        selectedMenu === ProfileMenuType.DRIVER_INFORMATION
                    }
                    onClick={onClickMenu(
                        ProfileMenuType.DRIVER_INFORMATION,
                        onMenuChange
                    )}
                >
                    <ListItemText
                        style={{
                            color: driverInformationHasError ? "red" : "",
                        }}
                        primary={`Informações do piloto ${
                            driverInformationHasError ? "*" : ""
                        }`}
                    />
                </ListItem>
                {loggedUser.roles.includes(Role.ADMIN) && <Divider />}
                {loggedUser.roles.includes(Role.ADMIN) && (
                    <ListItem
                        button
                        selected={selectedMenu === ProfileMenuType.ROLES}
                        onClick={onClickMenu(
                            ProfileMenuType.ROLES,
                            onMenuChange
                        )}
                        hidden={loggedUser.roles.includes(Role.ADMIN)}
                    >
                        <ListItemText primary="Permissões" />
                    </ListItem>
                )}
                <Divider />
                <ListItem
                    button
                    selected={selectedMenu === ProfileMenuType.PASSWORD_RESET}
                    onClick={onClickMenu(
                        ProfileMenuType.PASSWORD_RESET,
                        onMenuChange
                    )}
                >
                    <ListItemText primary="Senha" />
                </ListItem>
            </List>
        </BoxCard>
    );
};

export default ProfileMenu;
